import { ChangeDetectionStrategy, Component, OnChanges, OnInit, Input, SimpleChanges } from "@angular/core";
import { FeedbackBlockKind, FeedbackBlockIcons } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-micro-block",
    templateUrl: "./sps-micro-block.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsMicroBlockComponent implements OnInit, OnChanges {
    static readonly displayName = "sps-micro-block";
    static readonly props = {
        kind: "FeedbackBlockKind",
        message: { type: "string", required: true },
    };

    @Input() kind: FeedbackBlockKind = FeedbackBlockKind.INFO;
    @Input() message: string;

    _icon: string;

    ngOnInit() {
        if (!this.message) {
            throw new Error("sps-micro-block: message is required");
        }
        this._icon = FeedbackBlockIcons[this.kind];
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._icon = FeedbackBlockIcons[this.kind];
        }
    }
}
